<template>
  <div class="table-container" >
    <div v-if="!isNotEmpty" class="no-data"> <center> No data to display! </center> </div>
      <div v-if="isNotEmpty" class="table-not-empty">
        <div class="container-fluid" id="test">

            <div class="list-header">
              <div class="row new-width">
                <div class="col-sm-1 col-xs-1">
                      <input @click="selectAll($event)" type="checkbox" class="hidden-box" id="table-header-checkbox">
                      <label for="table-header-checkbox" class="check--label" id="table-header-checkbox-label">
                        <span class="check--label-box"></span>
                      </label>
                </div>
                <div class="col-sm-2 col-xs-10 table-heading" v-for="(heading, key) in titleMap" :key="key" @click="orderBy(key)">{{ heading }} <img src="src/assets/column-sort.svg" alt="">
                </div>
              </div>
            </div>
            <div class="table-body-container">
              <div class="list-body" v-for="(row, index) in page" :key="index">
                  <span v-show="filterdRow(row)">
                    <p class="grouping-caption" v-if="showNewGrouping(row)">{{ row[groupBy] }}</p>
                    <div class="row list-container new-width" :class="{'list-container-selected': isSelected(row)}">
                      <div class="col-sm-1 col-xs-1">
                        <input @click="selectCheckbox($event, row.id)" type="checkbox" class="hidden-box" :id="row.id" :value="row.id"  :key="row.id" v-model="selectedRows">
                        <label :for="row.id" class="check--label">
                          <span class="check--label-box"></span>
                        </label>
                      </div>
                      <div class="col-sm-2 col-xs-10" v-for="(column, key) in titleMap" :key="key">
                       <router-link :to="renderEndpoint(row)" :class="getClass(row, key)">{{ row[key] }}</router-link>
                      </div>
                    </div>
                  </span>
              </div>
            </div>
        </div>
        <div class="paginator">
          <div class="row paginator-width">
            <button class="col-sm-1 page-buttons previous" :disabled="disablePrevious" @click="previous()">previous</button>
            <button class="col-sm-1 page-buttons">{{ currentPage }} of {{ numberOfPages }} <img src="src/assets/counter-arrow.svg" alt=""> </button>
            <button class="col-sm-1 page-buttons next" @click="next()" :disabled="disableNext">next</button>
          </div>
        </div>
    </div>
  </div>

</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import $ from 'jquery';
import _ from 'lodash';
import store from '../store.js';
import constants from '../constants.js';
import Vue from 'vue';
var currentGrouping = '';
var trackKey = '';
var beforeEnd = 0;

export default {
    created(){
      this.to = this.pageSize;
    },
    updated() {
      if (this.tableName === constants.WIZARD_DATA_SOURCE){
        let ds = this.reportObject['data_sources'];
        ds.forEach(function(value, index){
          let element = $('#' + value.id);
          $(element).prop('checked', true);
        });
      }else{
        let id = this.reportObject[this.tableName];
        let element = $('#' + id);
        $(element).prop('checked', true);
      }

    },
    beforeDestroy: function(){
      store.state.filteredList = [];
    },
    props: {
      selectType: {default: 'single'},
      tableName: { default: '' },
      tableBody: { default: () => ({})},
      pageSize: {default: 20},
      titleMap: { default: () => ({}) },
      endPoint: { default: '' }
    },
    data () {
      return {
        page: [],
        currentPage: 1,
        pageTracker: 1,
        from: 0,
        to: 0,
        selectedRows: [],
        filtering: 0,
        dataSources: []

      };
    },
    computed: {
      ...mapState({
        groupBy: state => state.groupBy,
        group: state => state.group,
        sortingOrder: state => state.sortingOrder,
        reportObject: state => state.reportObject
      }),
      isNotEmpty: function(){
        let _isNotEmpty = true;
        if(Object.keys(this.tableBody).length == 0){
          _isNotEmpty = false;
        }
        return _isNotEmpty;
      },
      filteredList: function(){
        return store.state.filteredList;
      },
      getFilteredObjects: function(){
        var filtered = this.tableBody.filter(function(row){
          return this.indexOf(row.id) >= 0;
        },this.filteredList);
        return filtered;
      },
      pages: function(){
        var source;
        if (this.filteredList.length != 0){
          source = this.getFilteredObjects;
        }else{
          source = this.tableBody;
        }
        if(source.length < this.from){
          this.from = 0;
          this.to = this.pageSize;
          this.currentPage = 1;
        }
        if(this.groupBy !== null){
          this.page = _.slice(source.sort(this.compare(this.groupBy)), this.from, this.to);
        }else{
          this.page = _.slice(source, this.from, this.to);
        }
        return source;
      },
      numberOfPages: function(){
        return  Math.ceil(this.pages.length/this.pageSize);
      },
      disableNext: function(){
          if (this.to >= this.pages.length)return true;
      },
      disablePrevious: function(){
        if(this.from == 0)return true;
      },
    },
    methods:{
      selectCheckbox: function (event, id) {
        if (this.tableName === constants.WIZARD_DATA_SOURCE){
          store.dispatch('addDataSourceToReport', id)
        }
        if (this.tableName === constants.WIZARD_MEA){
          if(store.state.reportObject[constants.WIZARD_INDICATORS] !==undefined){
            delete store.state.reportObject[constants.WIZARD_INDICATORS];
          }
        }
        let checkedCount = 0;
        $('input:checkbox').each(function () {
          if ($(this).prop('checked') === true) {
            // console.log('checked inputs', $(this));
            checkedCount++
          }
        });
        // console.log(checkedCount);
        if (this.selectType == 'single' && checkedCount > 1) {
          event.preventDefault();
        }else if (this.selectType == 'single' && checkedCount === 1){
            let data = {key:this.tableName, info:id}
            store.dispatch('updateReportObject', { data })
        }else if (this.selectType == 'single' && checkedCount === 0) {
          store.dispatch('removeFromReportObject', this.tableName);
        }
      },
      selectAll: function(event){
        if (this.selectType === 'single'){
          event.preventDefault();
          return
        }
        let checkbox = $('#table-header-checkbox');
        // console.log('selectAll', $(checkbox).prop('checked'));
        if($(checkbox).prop('checked') === true){
          $('input:checkbox').prop('checked', true);
        }else{
          $('input:checkbox').prop('checked', false);
        }
      },
      next: function(){
        this.currentPage++;
        var lastPage = this.pages.length;
        if(this.to >= lastPage || (this.to + this.pageSize) >= lastPage ){
          this.from = this.to;
          beforeEnd = this.to;
          this.to = lastPage;
        }else{
          this.from = this.to;
          this.to = this.to + this.pageSize;
        }
      },
      previous: function(){
        this.currentPage--;
        if (this.to == this.pages.length){
          this.to = beforeEnd;
          this.from = this.from - this.pageSize;
        }else{
          this.from = this.from - this.pageSize;
          this.to = this.to - this.pageSize;
        }
      },
      filterdRow: function(row){
        var found = false;
        if(this.filteredList.length == 0){
          return true;
        }else{
          for (var i = 0; i < this.filteredList.length; i++) {
            if(this.filteredList[i] == row.id){
              found = true;
            }
          }
          return found;
        }
      },
      // orders the table and sorts the rows into their specific groupings
      showNewGrouping: function(row){
        var showNewGrouping = false;
        if(this.groupBy !== null && trackKey == this.groupBy){
          var key = this.groupBy;
          if (currentGrouping == row[key]){
            showNewGrouping = false;
          }
          else if (currentGrouping != row[key]){
            currentGrouping = row[key];
            showNewGrouping =  true;
          }
          return showNewGrouping;
        }
      },
      // compare function used to sort tables by column
      compare: function(key){
        if(key !== null) trackKey = key;
        return function(a, b){
          if (a[key] < b[key])return -1;
          if (a[key] > b[key])return 1;
          return 0;
        };
      },
      // orders columns in ascending order on click
      orderBy: function(column){
        this.page.sort(this.compare(column));
      },
      renderEndpoint: function(row){
        var endpoint = this.endPoint;
        var newEndpoint;
        var replaceWith;
        var key;
        if (endpoint == ''){
          return '';
        }
        newEndpoint = endpoint.replace(/\{\{(.*?)\}\}/gi, function(x){
          replaceWith = x.replace('{{', '');
          replaceWith = replaceWith.replace('}}', '');
          key = replaceWith.trim();
          return x = row[key];
        });
        return newEndpoint;
      },
      isSelected: function(row) {
        return this.selectedRows.indexOf(row.id) != -1;
      },
      getClass: function(row, key) {
        return key == 'status' ? `status ${row[key]}` : '';
      }
  }
};
</script>

<style lang="scss" scoped>
@import "../css/constants";
button:focus {
  outline:0;
}
button:disabled,
button[disabled]{
  background-color:transparent;
  color: #969494;
}
.no-data{
  color:grey;
}

.page-buttons{
  font-family: 'Roboto', sans-serif;
  font-weight: thin;
  font-size: 12px;
  box-shadow: 1px solid #e4e4e4;
  color:#5F5E5E;
}

.previous, .next {
  width: 70px !important;
}

.paginator{
  width: 100vh;
  padding-left: $p16;
  padding-right: $p16;
  margin: $p24 auto 0 auto;
  width: 100%;
  z-index: 999;
  
  .paginator-width {
    text-align: center;
    width: 350px;
    margin: 0 auto;
  }
}


.paginator button{
  padding: 4px 8px;
    border-radius: 2px;
    padding-top: 6px;
    margin-right: $p8;
  text-transform: capitalize;
  outline: none;
}
.paginator button:nth-child(2) {
  text-transform: lowercase;
  padding-right: 6px;
}
.grouping-caption{
  color:grey;
  font-size: 15px;
  padding-bottom:10px;
  padding-top: 10px;
}

a{
  color: #5F5E5E;

}
a:focus, a:hover {
    color: #014c8c;
    text-decoration: none;
}
.list-body{
  font-size: $p14;
  margin-bottom: $p4;
}

.list-body:last-child {
  margin-bottom: 0;
}
.list-container{
  background-color: white;
  padding-top: $p16;
  padding-bottom: $p16;
  border-radius: 2px;
  box-shadow: 0px 0 2px 0 #ECECEC;
}
.list-container:nth-child(n+2) > div > * {
  vertical-align: -2px;
  line-height: 0;
}
.list-header{
  padding-bottom:10px;
}
.container-fluid:last-child{
  border-bottom: 1px solid #eceeef;
}
.new-width {
      margin-left: 0px;
  }
// @media (min-width: 576px){
//
//   .paginator-width .col-sm-1{
//     max-width: 6.333333%!important;
//     padding-right: 0px;
//   }
//   .col-sm-2 {
//       max-width: 15%;
//   }
// }
.container-fluid{

}

//Table Headings
.table-heading{
  cursor: pointer;
    color: $blue;
    font-size: $p14;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

//Checkboxes
#table-header-checkbox-label {
  margin-top: -2px;
}
.col-sm-1 {
  flex: 0 0 0;
  padding-left: $p16;
  padding-right: 0;
  width: auto;
}
.hidden-box {
  position: absolute;
  top: -9999px;
  left: -9999px;
  display: none;
  appearance: none;
  opacity: 0;
}
.check--label-box {
  display: flex;
  align-self: center;
  position: relative;
  height: $p16;
  width: $p16;
  background: $gray3;
  border: 1px solid $gray4;
  border-radius: 3px;
  cursor: pointer;
}
// checked
.hidden-box:checked + .check--label {
  background-color: none;
  border-radius: 3px;
  .check--label-box {
    background-color: $blue;
    border: 1px solid $blue;
     &:after {
      content: '';
      display: block;
      position: absolute;
      top: 1px;
      left: 4px;
      width: 6px;
      height: 9px;
      border: 2px solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
}
//highlight list item
.list-container-selected {
  background: #F0F5FF;
  border-radius: 2px;
  transition: all 0.2s ease;
}

.status {/* Rectangle: */
  border-radius: 2px;
  text-transform: capitalize;
  padding-left: 4px;
  padding-right: 4px;
  font-size: $p12;
  padding-top: 2px;
  &.active {
    color: $gray6;
    background: rgba(127,127,127,0.15);
  }
}

.table-container{
  height: calc(100% - 103px);
}

.table-not-empty{
  height: 100%;

  .container-fluid{
    height: calc(100% - 60px);
  }

  .list-header{
    height: 30px;
  }

  .table-body-container{
    height: calc(100% - 30px);
    margin: 0;
    padding: 0 0 30px 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;

    &::-webkit-scrollbar { width: 8px; }
    &::-webkit-scrollbar-track-piece { background-color: transparent; }
    &::-webkit-scrollbar-track {
      // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      background-color: transparent;
      border-radius: 30px;
    }

    &::-webkit-scrollbar-thumb {
      cursor: pointer;
      background: -webkit-linear-gradient(to right, #35B8FB, #56CCF2);
      background: linear-gradient(to right, #35B8FB, #56CCF2);
      outline: 1px solid slategrey;

      border-radius: 30px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);

      &:hover { background: #35B8FB; }
    }
  }

  .paginator{
        height: 50px;
        padding-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GenericReportTable.vue